
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aktualnosci/[id]",
      function () {
        return require("private-next-pages/aktualnosci/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aktualnosci/[id]"])
      });
    }
  